function isDataOrBlobUrl(value) {
  return /^(data:|blob:)/i.test((value || "").trim());
}

function getMediaCdnBase() {
  const fromEnv = String(
    process.env.REACT_APP_CDN_DOMAIN ||
      process.env.REACT_APP_CLOUDFRONT_DOMAIN ||
      ""
  )
    .trim()
    .replace(/^['"]|['"]$/g, "")
    .replace(/\/+$/, "");

  if (!fromEnv) {
    console.error(
      "[cdnMediaUrl] Missing REACT_APP_CDN_DOMAIN (or REACT_APP_CLOUDFRONT_DOMAIN) in .env"
    );
  }
  return fromEnv;
}

/**
 * Convert Mosida S3 URLs / object keys to the public CloudFront CDN URL.
 * CDN host must come from .env — no hardcoded fallback.
 */
export function toCdnMediaUrl(url) {
  const trimmed = String(url || "").trim();
  if (!trimmed) return "";

  const cdnBase = getMediaCdnBase();
  if (!cdnBase) return trimmed;

  if (trimmed.startsWith(cdnBase)) return trimmed;
  if (/cloudfront\.net/i.test(trimmed)) return trimmed;

  if (trimmed.includes("amazonaws.com")) {
    try {
      const parsed = new URL(trimmed);
      const key = parsed.pathname.startsWith("/")
        ? parsed.pathname.slice(1)
        : parsed.pathname;
      return key ? `${cdnBase}/${decodeURIComponent(key)}` : trimmed;
    } catch {
      return trimmed;
    }
  }

  if (!/^https?:\/\//i.test(trimmed) && !isDataOrBlobUrl(trimmed)) {
    const key = trimmed.replace(/^\/+/, "");
    return key ? `${cdnBase}/${key}` : trimmed;
  }

  return trimmed;
}
